import * as types from '../../mutation-types'
import lazyLoading from './lazyLoading'
// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'

// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    {
      name: 'Сценарии',
      path: '/scenarios',
      meta: {
        label: 'Сценарии',
        labelTrans: 'scenarios.scenarios',
        icon: 'fa-comments',
        link: 'scenarios/Scenarios.vue'
      },
      component: lazyLoading('scenario/Scenarios')
    },
    {
      name: 'Рассылки',
      path: '/campaigns',
      meta: {
        label: 'Рассылки',
        // label: this.$t('campaigns.daily'),
        labelTrans: 'campaigns.campaigns',
        icon: 'fa-phone-square',
        link: 'campaigns/Campaigns.vue'
      },
      component: lazyLoading('campaigns/Campaigns')
    },
    {
      name: 'Ежедневные Рассылки',
      path: '/campaigns/daily',
      meta: {
        // label: '└─Ежедневные',
        labelTrans: 'campaigns.dailyLabel',
        // icon: 'fa-phone-square',
        link: 'campaigns/daily/DailyCampaigns.vue'
      },
      component: lazyLoading('campaigns/daily/DailyCampaigns.vue')
    },
    {
      name: 'Лицевой счёт',
      path: '/billing',
      meta: {
        label: 'Лицевой счёт',
        labelTrans: 'billing.billing',
        link: 'billing/Balance.vue',
        icon: 'fa-wallet'
      },
      component: lazyLoading('billing/Balance.vue')
    },

    {
      name: 'Аналитика затрат',
      path: '/billing/summary',
      meta: {
        labelTrans: 'billing.summaryLabel',
        // icon: 'fa-phone-square',
        link: 'billing/BillingSummaryDashboard.vue'
      },
      component: lazyLoading('billing/BillingSummaryDashboard.vue')
    },

    {
      name: 'Детализации',
      path: '/billing/details',
      meta: {
        labelTrans: 'billing.detailsLabel',
        // icon: 'fa-phone-square',
        link: 'billing/BillingDetails.vue'
      },
      component: lazyLoading('billing/BillingDetails.vue')
    },

    {
      name: 'Уведомления',
      path: '/billing/notifications',
      meta: {
        labelTrans: 'billing.notificationsLabel',
        // icon: 'fa-phone-square',
        link: 'billing/BillingNotifications.vue'
      },
      component: lazyLoading('billing/BillingNotifications.vue')
    },
    // {
    //   name: 'Архив рассылок',
    //   path: '/archive',
    //   meta: {
    //     label: 'Архив рассылок',
    //     icon: 'fas fa-archive',
    //     link: 'campaigns/Archive.vue'
    //   },
    //   component: lazyLoading('campaigns/Archive')
    // },
    {
      name: 'Пользователи',
      path: '/users',
      meta: {
        label: 'Пользователи',
        labelTrans: 'users.users',
        icon: 'fa-user',
        link: 'users/Users.vue'
      },
      component: lazyLoading('users/Users')
    },
    {
      name: 'Настройка прав',
      path: '/permissions',
      meta: {
        label: 'Настройка прав',
        labelTrans: 'permissions.permissions',
        icon: 'fa-tasks',
        link: 'settings/Permissions.vue'
      },
      component: lazyLoading('settings/Permissions')
    },
    {
      name: 'Настройка приложения',
      path: '/appconfig',
      meta: {
        label: 'Настройка приложения',
        labelTrans: 'appConfig.appConfig',
        icon: 'fa-cogs',
        link: 'settings/AppConfig.vue'
      },
      component: lazyLoading('settings/AppConfig')
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU](state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js